"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-us" ref={ref} className={`py-16 md:py-24 px-6 bg-background transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[1rem]"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {}
          <div className="space-y-6">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground leading-tight">
              About AT & E
            </h2>
            <p className="text-foreground/80 text-lg leading-relaxed">
              AT & E is a specialized broker delivering equipment leasing, delivery, and pickup solutions for the construction sector. Operating from Ripon, California, we partner with industry leaders Sunbelt Rentals and United Rentals to provide reliable access to a broad inventory of heavy machinery and tools.
            </p>
            <p className="text-foreground/80 text-lg leading-relaxed">
              By handling logistics and paperwork, we streamline project timelines and reduce overhead for contractors. Our responsive service team ensures timely equipment arrival and efficient return, supporting construction companies in maintaining productivity while managing costs effectively.
            </p>
          </div>

          {}
          <div className="relative overflow-hidden rounded-lg shadow-medium">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1507189/img/at_and_e_team_photo.png" alt="AT & E Team" className="w-full h-auto object-cover transition-transform duration-[350ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:scale-[1.03]" />
          </div>
        </div>
      </div>
    </section>;
}